module.exports = __webpack_public_path__ + "img/script-text-outline.892d79ea.svg";